import { useEffect, useState } from "react";

// We intentionally detect "touch-like" environments (phones/tablets) to keep desktop UI unchanged.
export function useIsMobileTouch(): boolean {
  const [isMobileTouch, setIsMobileTouch] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(hover: none) and (pointer: coarse)");
    const update = () => {
      const coarsePointer = mq.matches;
      const hasTouchPoints = (navigator.maxTouchPoints || 0) > 0;
      const mobileUa = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");
      const narrowViewport = window.innerWidth <= 1024;
      // Keep desktop unchanged, but still enable mobile swipe UI in emulators where coarse pointer media query is flaky.
      setIsMobileTouch(Boolean(coarsePointer || (hasTouchPoints && narrowViewport) || mobileUa));
    };
    update();
    mq.addEventListener("change", update);
    window.addEventListener("resize", update);
    return () => {
      mq.removeEventListener("change", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return isMobileTouch;
}
